import { UserCategoriesEntity } from '../entities';
import { BaseEntity, IBaseTransformerRepository } from '@eigen3m/react-base-frontend';
import { UserCategoriesTransformer } from '../transformers';

export function makeUserCategoriesTransformer<
  E extends BaseEntity = UserCategoriesEntity,
>(): IBaseTransformerRepository<E> {
  return new UserCategoriesTransformer<E>();
}
